import { Classes } from "@blueprintjs/core";
import React, { ReactNode } from "react";
import styled from "styled-components";

import { HexButton } from "./HexButton";
import { HexDialog } from "./HexDialog";

const StyledDialog = styled(HexDialog)`
  &&&& {
    width: 90vw;
    max-width: 2000px;
    height: 90vh;
    padding: 0;
    margin: 0 auto;

    .${Classes.DIALOG_HEADER} {
      padding: 0 12px 0 20px;
    }

    .${Classes.HEADING} {
      padding-right: 5px;
    }

    @media (max-width: ${({ theme }) => `${theme.mediaQuery.LARGE}px`}) {
      width: 90%;
    }
  }
`;

const StyledDialogBody = styled.div`
  display: flex;
  flex: auto;
  flex-direction: row;
  overflow: hidden;

  background-color: ${({ theme }) => theme.backgroundColor.LOGIC};
  border-top: 1px solid ${({ theme }) => theme.borderColor.MUTED};

  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
`;

const LeftPaneDiv = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 300px;

  background-color: ${({ theme }) => theme.backgroundColor.DEFAULT};
  border-right: 1px solid ${({ theme }) => theme.borderColor.MUTED};
`;

const ItemListDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;

const ButtonsDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;

  border-top: 1px solid ${({ theme }) => theme.borderColor.MUTED};
`;

interface HexPanelDialogProps {
  isOpen: boolean;
  onClose: () => void;
  itemList: ReactNode;
  chooseButton: ReactNode;
  rightPanel: ReactNode;
  title: ReactNode;
}

export const HexPanelDialog: React.ComponentType<HexPanelDialogProps> =
  React.memo(function HexPanelDialog({
    chooseButton,
    isOpen,
    itemList,
    onClose,
    rightPanel,
    title,
  }) {
    return (
      <StyledDialog isOpen={isOpen} title={title} onClose={onClose}>
        <StyledDialogBody>
          <LeftPaneDiv>
            <ItemListDiv>{itemList}</ItemListDiv>
          </LeftPaneDiv>
          {rightPanel}
        </StyledDialogBody>
        <ButtonsDiv>
          <HexButton onClick={onClose}>Cancel</HexButton>
          {chooseButton}
        </ButtonsDiv>
      </StyledDialog>
    );
  });
